module.exports = __webpack_public_path__ + "static/media/found3.9c950f4d.png";